import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class AdapterService {
    adaptAll(items: any[]): any[] {
        return items.map((item) => this.adaptSingle(item));
    }

    adaptSingle(item: any): any {
        const newItem = {
            device_type: item.square_device_type.name,
            deviceType: item.square_device_type,
            location: item.square_receipt_location_name,
            ...item,
        };

        const { square_receipt_location_name, ...rest } = newItem;
        return rest;
    }
}
